// import Cookies from "js-cookie";

// export const getAccessToken = () => {
//   return Cookies.get("current_session", false);
// };

// export const setAccessToken = (token) => {
//   return Cookies.set("current_session", token, { expires: 7 });
// };

// export const removeAccessToken = () => {
//   return Cookies.remove("current_session");
// };

// export const getRefreshToken = () => {
//   return Cookies.get("refresh_session", false);
// };

// export const setRefreshToken = (refresh_token) => {
//   return Cookies.set("refresh_session", refresh_token, { expires: 7 });
// };

// export const removeRefreshToken = () => {
//   return Cookies.remove("refresh_session");
// };
import Cookies from "js-cookie";

export const getAccessToken = () => {
  return Cookies.get("current_session");
};

export const setAccessToken = (token) => {
  return Cookies.set("current_session", token, { expires: 7 });
};

export const removeAccessToken = () => {
  return Cookies.remove("current_session");
};

export const getRefreshToken = () => {
  return Cookies.get("refresh_session");
};

export const setRefreshToken = (refresh_token) => {
  return Cookies.set("refresh_session", refresh_token, { expires: 7 });
};

export const removeRefreshToken = () => {
  return Cookies.remove("refresh_session");
};

// NEW: Clear all authentication data
export const clearAllSessions = () => {
  removeAccessToken();
  removeRefreshToken();
  
  // Clear all cookies that might be related to sessions
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    // Remove any session-related cookies
    if (name.includes("session") || name.includes("token")) {
      Cookies.remove(name);
    }
  }
  
  // Clear storage
  sessionStorage.clear();
  localStorage.removeItem("currentUser");
};